import React from "react";
import { DropdownSelect } from "../DropdownSelect";
import { checkEmptyObject } from "../../../services";
import style from "./styles.scss";

const LevelSelectorLoader = props => {
  const {
    child,
    isRequired,
    showPlaceholder,
    title,
    childCount,
    isColumn,
    isMultiRows,
    showAllLevel,
    field,
    placeholder,
    className
  } = props;

  const calculateStyle = () => {
    const { childCount, number, isMultiRows, chosenValue } = props;

    if (chosenValue) {
      return {
        display: "none"
      };
    }

    if (!isMultiRows) {
      const width = 100 / childCount;

      return {
        width: `${width}%`,
        left: `${width * number}%`
      };
    }

    return null;
  };

  return (
    <React.Fragment>
      <DropdownSelect
        field={field}
        title={title}
        placeholder={placeholder}
        options={[]}
        style={calculateStyle()}
        value={null}
        onChange={() => {}}
        isRequired={isRequired}
        isDisabled={true}
        showPlaceholder={showPlaceholder}
        className={className}
      />
      {checkEmptyObject(child) ? (
        <div
          className={
            isColumn ? style.childColumnComponent : style.childComponent
          }
        >
          <LevelSelectorLoader
            className={className}
            childCount={childCount}
            {...child}
            onChange={() => {}}
            isMultiRows={isMultiRows}
            isRequired={isRequired}
            isDisabled={true}
            showAllLevel={showAllLevel}
            showPlaceholder={showPlaceholder}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};

LevelSelectorLoader.defaultProps = {
  title: "",
  placeholder: "Odaberite",
  child: {},
  className: "",
  isMultiRows: false,
  isRequired: false,
  isDisabled: false,
  chosenValue: "",
  number: 0,
  showAllLevel: false
};

export default LevelSelectorLoader;



// WEBPACK FOOTER //
// ./src/components/FormControls/LevelSelector/LevelSelectorLoader.tsx